<template>
    <transition v-if="securityPackages.length > 0 || extenders.length > 0" name="cart">
        <div id="popular-addons">
            <div class="card has-footer">
                <h1 class="font-regular">{{ lang('Populära tillval','Popular addons') }}</h1>

                <setting-with-checkbox
                    v-if="securityPackages.length > 0"
                    v-model="selectedSecurityPackages"
                    :options="securityPackages"
                    :title="lang('Säkerhetspaket','Security packages')"
                    :description="availableSecurityPackages[0].description"
                />

                <setting-with-checkbox
                    v-if="extenders.length > 0"
                    v-model="selectedExtenders"
                    :options="extenders"
                    :title="lang('Utrustning','Equipment')"
                    :description="availableExtenders[0].description"
                />

                <configuration-footer
                    :validates="selectedSecurityPackages.length > 0 || selectedExtenders.length > 0"
                    :monthly-price="monthlyPrice"
                    :one-time-cost="oneTimeCost"
                    @add="addToCart"
                />
            </div>
            <div class="flex justify-center">
                <a :href="route('front.order.create')" class="btn btn-lg is-primary">
                    {{ lang('Fortsätt till kassan','Continue to checkout') }}
                </a>
            </div>
        </div>
    </transition>
</template>

<script>
    import SettingWithCheckbox from '../Settings/SettingWithCheckbox';
    import ConfigurationFooter from '../ConfigurationFooter';

    export default {
        components: {
            SettingWithCheckbox,
            ConfigurationFooter,
        },
        props: {
            availableExtenders: {
                type: Array,
                required: true,
            },
            availableSecurityPackages: {
                type: Array,
                required: true,
            },
        },
        data() {
            return {
                selectedSecurityPackages: [],
                selectedExtenders: [],
            };
        },
        computed: {
            monthlyPrice() {
                return format_sek(this.selectedSecurityPackageObjects.reduce((prev, next) => {
                    const price = next.hasOwnProperty('discounted_monthly_price')
                        ? next.discounted_monthly_price
                        : next.monthly_price;

                    return prev + price;
                }, 0));
            },
            oneTimeCost() {
                return format_sek(this.selectedExtenderObjects.reduce((prev, next) => {
                    return prev + next.price;
                }, 0));
            },
            securityPackages() {
                return this.availableSecurityPackages.map((securityPackage) => {
                    const price = securityPackage.hasOwnProperty('discounted_monthly_price')
                        ? securityPackage.discounted_monthly_price
                        : securityPackage.monthly_price;

                    return {
                        name: securityPackage.name,
                        value: securityPackage.article_id,
                        valuePrice: format_sek_per_month(price),
                        label: securityPackage.name,
                    };
                });
            },
            extenders() {
                return this.availableExtenders.map((extender) => {
                    return {
                        name: extender.name,
                        value: extender.article_id,
                        valuePrice: extender.price_label,
                        label: extender.name,
                    };
                });
            },
            selectedSecurityPackageObjects() {
                return this.selectedSecurityPackages.flatMap((id) => {
                    return this.availableSecurityPackages.find((securityPackage) => securityPackage.article_id === id);
                });
            },
            selectedExtenderObjects() {
                return this.selectedExtenders.flatMap((id) => {
                    return this.availableExtenders.find((extender) => extender.article_id === id);
                });
            },
        },
        methods: {
            async addToCart() {
                const articles = [];

                this.selectedSecurityPackageObjects.forEach((securityPackage) => {
                    articles.push({
                        articleClass: securityPackage.article_class,
                        articleId: securityPackage.article_id,
                    });
                });

                this.selectedExtenderObjects.forEach((extender) => {
                    articles.push({
                        articleClass: extender.article_class,
                        articleId: extender.article_id,
                    });
                });

                const response = await axios.post(route('front.api.cart-items.store'), {
                    articles,
                });

                EventBus.$emit('cartDataUpdated', response.data);
                this.productsAddedToCart = true;
                this.$emit('completed');
            },
        },
    };
</script>
